import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DEFAULT_LOADER_CONFIG, LoaderConfig } from './loader.config';

@Component({
  selector: 'loader',
  imports: [CommonModule],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss'
})
export class LoaderComponent implements OnInit {
  @Input() config?: LoaderConfig;
  
  @Input() fullScreen?: boolean;
  @Input() type?: 'spinner' | 'progress' | 'dots';
  @Input() text?: string;
  @Input() overlay?: boolean;
  @Input() customClass?: string;
  @Input() size?: 'sm' | 'md' | 'lg';
  
  effectiveConfig: LoaderConfig = DEFAULT_LOADER_CONFIG;
  
  ngOnInit(): void {
    this.effectiveConfig = {
      ...DEFAULT_LOADER_CONFIG,
      ...this.config,
      fullScreen: this.fullScreen ?? this.config?.fullScreen ?? DEFAULT_LOADER_CONFIG.fullScreen,
      type: this.type ?? this.config?.type ?? DEFAULT_LOADER_CONFIG.type,
      text: this.text ?? this.config?.text,
      overlay: this.overlay ?? this.config?.overlay ?? DEFAULT_LOADER_CONFIG.overlay,
      customClass: this.customClass ?? this.config?.customClass,
      size: this.size ?? this.config?.size ?? DEFAULT_LOADER_CONFIG.size
    };
  }
  
  getLoaderClasses(): string {
    const classes = ['loader-container'];
    
    if (this.effectiveConfig.fullScreen) {
      classes.push('loader-fullscreen');
    }
    
    if (this.effectiveConfig.overlay) {
      classes.push('loader-overlay');
    }
    
    if (this.effectiveConfig.customClass) {
      classes.push(this.effectiveConfig.customClass);
    }
    
    return classes.join(' ');
  }
  
  getSpinnerClasses(): string {
    const classes = ['loader'];
    
    if (this.effectiveConfig.size) {
      classes.push(`loader-${this.effectiveConfig.size}`);
    }
    
    return classes.join(' ');
  }
}
